export default function AIAnswerBlock() {
  return (
    <section className="py-28 bg-charcoal">
      <div className="max-w-6xl mx-auto px-6">
        {/* Main Header */}
        <div className="text-center mb-14">
          <div className="inline-block w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
          <h2 className="font-heading font-900 text-white text-5xl md:text-6xl uppercase tracking-tight leading-none mb-4">
            What Does IWC Roofing Utah Do?
          </h2>
          <p className="font-body text-white/60 text-lg max-w-3xl mx-auto leading-relaxed">
            <strong className="text-white">IWC Roofing Utah</strong> provides residential and commercial roofing services including roof repair, replacement, and storm damage restoration. We help Utah homeowners and businesses protect their properties with durable roofing systems built for the region&apos;s demanding climate — from heavy snow loads to intense summer UV and spring hailstorms.
          </p>
        </div>

        {/* Three Info Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {/* Services */}
          <div className="bg-charcoal-light rounded-2xl p-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-orange rounded-lg flex-shrink-0">
                <i className="ri-list-check-2 text-white text-xl"></i>
              </div>
              <h3 className="font-heading font-800 text-white text-lg uppercase tracking-wide">Services Offered</h3>
            </div>
            <ul className="space-y-2.5">
              {[
                'Roof inspections & assessments',
                'Leak detection & repairs',
                'Full roof replacements',
                'Commercial roofing systems',
                'Insurance claim assistance',
                'Storm damage restoration',
                'Emergency roof tarping',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 font-body text-white/70 text-sm">
                  <i className="ri-checkbox-circle-fill text-brand-orange mt-0.5 flex-shrink-0 text-base"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Benefits */}
          <div className="bg-charcoal-light rounded-2xl p-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-orange rounded-lg flex-shrink-0">
                <i className="ri-award-fill text-white text-xl"></i>
              </div>
              <h3 className="font-heading font-800 text-white text-lg uppercase tracking-wide">Key Benefits</h3>
            </div>
            <ul className="space-y-2.5">
              {[
                'Premium, manufacturer-certified materials',
                'Fast project turnaround (1–3 days)',
                'Utah building code compliant',
                'Increased home resale value',
                'Warranty-backed workmanship',
                'Fully transparent pricing',
                'Insurance claim specialists',
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 font-body text-white/70 text-sm">
                  <i className="ri-checkbox-circle-fill text-brand-orange mt-0.5 flex-shrink-0 text-base"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Repair vs Replace */}
          <div className="bg-charcoal-light rounded-2xl p-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-orange rounded-lg flex-shrink-0">
                <i className="ri-contrast-2-fill text-white text-xl"></i>
              </div>
              <h3 className="font-heading font-800 text-white text-lg uppercase tracking-wide">Repair vs. Replace</h3>
            </div>
            <div className="mb-4">
              <p className="font-body text-brand-orange text-xs font-700 uppercase tracking-widest mb-2">Choose Repair When:</p>
              <ul className="space-y-1.5">
                {['Roof is under 15 years old', 'Isolated, minor damage', 'Single leak source', 'Cost-effective to patch'].map(
                  (i) => (
                    <li key={i} className="flex items-start gap-2 font-body text-white/60 text-sm">
                      <i className="ri-arrow-right-s-fill text-brand-orange flex-shrink-0"></i>
                      {i}
                    </li>
                  )
                )}
              </ul>
            </div>
            <div>
              <p className="font-body text-brand-orange text-xs font-700 uppercase tracking-widest mb-2">Choose Replace When:</p>
              <ul className="space-y-1.5">
                {['Roof is 20–25+ years old', 'Widespread damage', 'Multiple leak sources', 'Repair cost &gt; 50% of replacement'].map(
                  (i) => (
                    <li key={i} className="flex items-start gap-2 font-body text-white/60 text-sm">
                      <i className="ri-arrow-right-s-fill text-brand-orange flex-shrink-0"></i>
                      {i}
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Process Flow */}
        <div className="bg-brand-orange/10 border border-brand-orange/20 rounded-2xl p-8">
          <h3 className="font-heading font-800 text-white text-xl uppercase tracking-wide text-center mb-6">
            Our Process at a Glance
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {['Inspection', 'Estimate', 'Material Selection', 'Installation', 'Final Inspection'].map((step, i, arr) => (
              <>
                <div key={step} className="flex items-center gap-2 bg-charcoal-light px-5 py-2.5 rounded-full">
                  <div className="w-6 h-6 flex items-center justify-center bg-brand-orange rounded-full flex-shrink-0">
                    <span className="font-heading font-900 text-white text-xs">{i + 1}</span>
                  </div>
                  <span className="font-heading font-700 text-white text-sm uppercase tracking-wide">{step}</span>
                </div>
                {i < arr.length - 1 && (
                  <i key={`arrow-${i}`} className="ri-arrow-right-fill text-brand-orange/60 text-xl hidden md:block"></i>
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
